(function () {
  'use strict';

  var TIERS = [
    { threshold: 300000,  pct: 12 },
    { threshold: 500000,  pct: 15 },
    { threshold: 1000000, pct: 17 },
    { threshold: 1500000, pct: 20 },
  ];

  var MSGS = [
    '✨ Agrega {falta} más y estrena tu {pct}% de descuento',
    '🎁 ¡Bien! Solo {falta} más y tu descuento sube a {pct}%',
    '💜 ¡Ya casi! {falta} más y alcanzas el {pct}% de descuento',
    '👑 ¡Leyenda Lely! Agrega {falta} más y gana el {pct}% máximo',
  ];

  function fmt(n) {
    return '$' + Math.round(n).toLocaleString('es-CO');
  }

  // Construye la estructura HTML una sola vez
  function setup(widget) {
    if (widget.dataset.ready) return;
    widget.innerHTML =
      '<button class="lely-close" aria-label="Cerrar">&times;</button>' +
      '<div class="lely-header" id="lely-msg"></div>' +
      '<div class="lely-track"><div class="lely-fill" id="lely-fill"></div></div>' +
      '<div class="lely-labels">' +
        '<span id="lely-current"></span>' +
        '<span id="lely-next"></span>' +
      '</div>' +
      '<div class="lely-cta">Descuento al llegar a <strong id="lely-goal"></strong></div>';

    widget.querySelector('.lely-close').addEventListener('click', function () {
      hide(widget);
      widget._closedAt = widget._lastSubtotal;
    });

    widget.dataset.ready = '1';
  }

  function render(subtotal) {
    var widget = document.getElementById('lely-progress-widget');
    if (!widget) return;

    var curIdx = -1;
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (subtotal >= TIERS[i].threshold) { curIdx = i; break; }
    }
    var nxtIdx = curIdx + 1;

    if (nxtIdx >= TIERS.length) {
      hide(widget);
      return;
    }

    // No reabrir si el usuario cerro y el subtotal no cambio
    if (widget._closedAt !== undefined) {
      if (widget._closedAt === subtotal) return;
      widget._closedAt = undefined;
    }

    setup(widget);

    var nxt   = TIERS[nxtIdx];
    var prev  = curIdx >= 0 ? TIERS[curIdx].threshold : 0;
    var falta = nxt.threshold - subtotal;
    var pct   = Math.min(((subtotal - prev) / (nxt.threshold - prev)) * 100, 100);
    var msg   = MSGS[Math.min(nxtIdx, MSGS.length - 1)]
                  .replace('{falta}', fmt(falta))
                  .replace('{pct}', nxt.pct);

    document.getElementById('lely-msg').textContent     = msg;
    document.getElementById('lely-fill').style.width    = pct.toFixed(1) + '%';
    document.getElementById('lely-current').textContent = fmt(subtotal);
    document.getElementById('lely-next').textContent    = fmt(nxt.threshold);
    document.getElementById('lely-goal').textContent    = fmt(nxt.threshold);

    widget._lastSubtotal = subtotal;
    show(widget);
  }

  function show(widget) {
    widget.classList.remove('lely-hiding');
    widget.style.display = 'block';
  }

  function hide(widget) {
    widget.classList.add('lely-hiding');
    setTimeout(function () {
      widget.style.display = 'none';
      widget.classList.remove('lely-hiding');
    }, 300);
  }

  var lastSubtotal = null;

  function fetchAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subtotal = cart.total_price / 100;
        if (subtotal === lastSubtotal) return;
        lastSubtotal = subtotal;
        render(subtotal);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndRender);
  } else {
    fetchAndRender();
  }

  document.addEventListener('cart:updated',        fetchAndRender);
  document.addEventListener('cart:refresh',         fetchAndRender);
  document.addEventListener('theme:cart:updated',   fetchAndRender);

  setInterval(fetchAndRender, 3000);
})();
